export const CONTACTUS_CONSTANTS = 
{
     name: 'Nom',
     email: 'Adresse email',
     category: 'Catégorie',
     subject:'Sujet',
     message:'Tapez votre message ici ...',
     required: 'Ce champ est obligatoire',
     Error: 'Erreur',
     successMessage: 'Formulaire envoyé avec succès',
     serverError: 'Erreur server',
     emailMessageError: 'Ce champ doit être un email valide',
     submit:'Envoyer',
     //sitekey: '6LfI4AwrAAAAAKUJZbXsEEQogCUCoWe9vZZIiRy7'    
}
